<template>
  <div class="tab-container">
    <div :class="['tab-container__nav', navClass]">
      <ul class="tab-container__nav__items">
        <li
          v-for="(tab, tabIndex) in tabsIndexed"
          :key="tab.id"
          class="tab-container__nav__item"
        >
          <button
            type="button"
            @click="
              () => {
                if (!showNavIndices || tabsVisited.indexOf(tab.id) != -1)
                  showTab(tab.id);
              }
            "
            :class="
              Object.assign({}, buttonClass, {
                active: tab.id == activeTab,
                visited: tabsVisited.indexOf(tab.id) != -1,
              })
            "
          >
            <span
              v-if="showNavIndices"
              class="tab-container__nav__item__index"
              >{{ tabIndex + 1 }}</span
            >
            <span class="tab-container__nav__item__label">{{ tab.title }}</span>
          </button>
        </li>
      </ul>
    </div>

    <div
      :class="`tab-container__body tab-container__body--${activeTab}`"
      :key="activeTab"
    >
      <slot
        :name="activeTab"
        :showTab="showTab"
        :showNext="showNext"
        :showPrev="showPrev"
      ></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    initialTab: {
      type: Number,
      required: true,
    },
    navClass: {
      type: String,
    },
    buttonClass: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showNavIndices: {
      type: Boolean,
      default: false,
    },
    beforeSwitch: {
      type: Function,
    },
    onSwitch: {
      type: Function,
    },
  },
  computed: {
    tabsIndexed() {
      let tabsIndexed = this.tabsData;
      return tabsIndexed;
    },
  },
  data() {
    return {
      activeTab: this.initialTab,
      tabsData: this.tabs,
      tabsVisited: [],
    };
  },
  watch: {
    initialTab: function (newTab) {
      this.tabsVisited.push(this.activeTab);
      this.activeTab = newTab;
    },
  },
  methods: {
    async showTab(keyOrIndex) {
      let key = keyOrIndex;
      let setTab = true;

      if (this.beforeSwitch) {
        const result = await this.beforeSwitch(key);
        if (result === false) {
          return false;
        }
      }

      this.tabsVisited.push(this.activeTab);

      if (this.onSwitch) {
        setTab = await this.onSwitch(key);
      }

      if (setTab) {
        this.activeTab = key;

        Vue.nextTick(() => {
          this.$emit("switched", this);
        });
      }
    },
    showNext() {
      let currentIndex = this.tabsIndexed.findIndex(
        (t) => t.key === this.activeTab
      );

      this.showTab(currentIndex + 1);
    },
    showPrev() {
      let currentIndex = this.tabsIndexed.findIndex(
        (t) => t.key === this.activeTab
      );

      this.showTab(currentIndex - 1);
    },
  },
};
</script>